/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Grid, TextArea, Button, Notification, Card} from '@scuf/common';
import ActionLogTable from "../common/ActionLogTable";
import {isClosedState} from "../common/FaultsConst";
import {getFaultName, verifyAirtimeException} from "../../utils/Helpers";
import {Link} from "react-router-dom";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {reexportLLPacket} from "../../admin/learningLoop/LearningLoopActions";
import {getFaultSummary, getClosingReasonFromComments} from "../common/FaultsUtils";
import {fetchCloseComments} from "../../api/Faults";
import _ from "lodash";


class Summary extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            comment: '',
            closedPredefinedReasons : [],
            closedSelectedReason:'',
        }

        this.handleCommentChange = this.handleCommentChange.bind(this)
        this.handleSubmitSummary = this.handleSubmitSummary.bind(this)
    }

    componentDidMount() {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.fetchActionLog(this.props.fault.assetId, this.props.fault.faultId, external).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
        this.props.FaultActions.fetchCreatedFaults(this.props.fault.assetId, this.props.fault.faultId, external).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
        if (this.props.fault.actions === null) {
            this.props.FaultActions.fetchActions(this.props.fault.assetId, this.props.fault.faultId, external).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        }
        this.props.FaultActions.fetchComments(this.props.fault.assetId, this.props.fault.faultId, external).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
        this.fetchCloseCommentsOptions();
    }

    fetchCloseCommentsOptions() {
        fetchCloseComments()
            .then(response => {
                const options = response.map((opt) => opt.name)
                this.setState({closedPredefinedReasons: options})
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevState.closedPredefinedReasons.length !== this.state.closedPredefinedReasons.length || !_.isEqual(prevProps.fault.comments, this.props.fault.comments))
                && this.state.closedSelectedReason === '') {
            this.setState({closedSelectedReason: getClosingReasonFromComments(this.props, this.state.closedPredefinedReasons)})
        }
    }

    handleCommentChange(value) {
        this.setState({comment: value});
    }

    handleSubmitSummary() {
        const comment = this.state.comment
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        if (comment && comment.length > 0) {
            this.props.FaultActions.saveComment(this.props.fault.assetId, this.props.fault.faultId, this.state.comment, external)
                .then(() => {
                    this.redirectToFaultDetail()
                    reexportLLPacket(this.props.fault, external)
                })
                .catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                });
        } else {
            this.redirectToFaultDetail()
        }
    }

    redirectToFaultDetail() {
        const {history, userProfile} = this.props
        const external = userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        external ?
            history.push(`/airtime/asset/${this.props.fault.assetId}/faults/${this.props.fault.faultId}`)
            :
            history.push(`/assets/${this.props.fault.assetId}/faults/${this.props.fault.faultId}`)
        window.scrollTo(0, 0)
    }

    render() {
        const {fault, intl, userProfile} = this.props

        let fcClosedMessage;
        if (isClosedState(fault.details.faultConditionState)) {
            fcClosedMessage = <Notification
                className="read-only-info"
                hasIcon={true}
                severity="success">
                <FormattedMessage id="fault.troubleshoot.summary.info.fcclosed"/>
            </Notification>
        }

        let verificationWasSkipped = null;
        const isHda = userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)
        if(fault.verificationObservations.length === 0 && !isHda) {
            verificationWasSkipped =
                <Notification
                    className="read-only-info"
                    hasIcon={true}
                    severity="information">
                    <FormattedMessage id="fault.troubleshoot.summary.info.verificationSkipped"/>
                </Notification>
        }

        let fcCreatedMessage;
        if (fault.createdFaults.totalCount > 0) {
            fcCreatedMessage = <Notification
                className="created-faults-info"
                hasIcon={true}
                severity="information">
                <FormattedMessage id="fault.troubleshoot.summary.info.createdfcs"/>
                <ul>{fault.createdFaults.results.map(f => <li key={f.id} className={'state-' + f.faultConditionState}>
                    <div className='state-icon'/>
                    <div className='state-name'><FormattedMessage id={"fault.detail.state." + f.faultConditionState}/>
                    </div>
                    <Link to={
                        userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
                            `/airtime/asset/${f.asset.id}/faults/${f.id}`
                            :
                            `/assets/${f.asset.id}/faults/${f.id}`
                    } target="_self"><Button type="link">{getFaultName(f)}</Button></Link></li>)}</ul>
            </Notification>
        }

        let prevButton = '';
        if (fault.readOnly && isClosedState(fault.details.faultConditionState)) {
            prevButton = <Button content={intl.formatMessage({id: "fault.troubleshoot.button.verification"})} icon="caret-left" iconPosition="left" onClick={this.props.previousButtonClick}/>
        }

        return (
            <div id="summary-step">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <div>
                                {verificationWasSkipped}
                                {fcClosedMessage}
                                {fcCreatedMessage}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Header title={intl.formatMessage({id: "fault.detail.title.faultSummary"})} />
                                <Card.Content>
                                    {getFaultSummary(this.props, this.state.closedSelectedReason)}
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            <Card>
                                <Card.Header title={intl.formatMessage({id: "fault.detail.label.close.comment"})} />
                                <Card.Content>
                                    <TextArea value={this.state.comment} onChange={this.handleCommentChange}
                                              helperText={intl.formatMessage({id: "fault.detail.comment.warning"})}
                                              fluid/>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <div className="button-panel">
                    <div className="left">
                        {prevButton}
                    </div>
                    <div className="right">
                        <Button content={intl.formatMessage({id: "fault.troubleshoot.button.save"})} onClick={this.handleSubmitSummary} disabled={fault.readOnly} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Summary)))
